import pageflyNav from '../../handlebars/pagefly/navigation.handlebars';

const PageFlyNav = () => {
  const openClass = 'is-open';

  const toggleNav = () => {
    const $navToggleBtn = $('.pl-nav-collapse__action');
    const $toggleSection = $('.pl-nav-collapse, .pl-nav-links');

    $navToggleBtn.on('click', () => {
      $toggleSection.toggleClass(openClass);
    });

  };

  const renderNavigation = () => {
    const $navigations = $('.pagefly-nav-section-basic [data-collapsed-text]');

    $navigations.each(function() {
      const dataSet = this.dataset;
      const innerLinks = Object.keys(dataSet)
                          .filter((i) => i.indexOf('innerlink-') >= 0)
                          .sort((a, b) => { return a.slice(-1) > b.slice(-1); })
                          .map((i) => {
                            const linkPair = dataSet[i].split('|');

                            return {
                              linkName: linkPair[0],
                              linkDest: linkPair[1],
                            };
                          });
      const navData = {
        collapsedText: dataSet.collapsedText,
        innerLinks,
      };

      $(this).html(pageflyNav(navData));
    });
  };

  renderNavigation();
  toggleNav();

  document.querySelectorAll('.pl-nav-links a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      $('.pl-nav-collapse, .pl-nav-links').removeClass(openClass);

      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

    });
  });
};

export default PageFlyNav;
